jQuery(document).ready(function ($) {


    const $hamburger   = $('#js-hamburger');
    const $mobileMenu  = $('#js-mobile-menu');

    $hamburger.on('click', function () {
        const isOpen = $hamburger.hasClass('--open');

        $hamburger.toggleClass('--open', !isOpen);
        $hamburger.attr('aria-expanded', !isOpen);
        $mobileMenu.toggleClass('--visible', !isOpen);
        $mobileMenu.attr('aria-hidden', isOpen);
    });


    const $header = $('#site-header');

    $(window).on('scroll', function () {
        $header.toggleClass('--scrolled', $(this).scrollTop() > 10);
    });


    $(document).on('click', '[data-acc-btn]', function () {
        const $btn   = $(this);
        const $item  = $btn.closest('[data-acc-item]');
        const $panel = $item.find('[data-acc-panel]');
        const isOpen = $btn.attr('aria-expanded') === 'true';

        const $accordion = $item.closest('[data-accordion]');
        $accordion.find('[data-acc-item]').not($item).each(function () {
            $(this).find('[data-acc-btn]').attr('aria-expanded', 'false');
            $(this).find('[data-acc-panel]').attr('hidden', true);
        });

        $btn.attr('aria-expanded', !isOpen);

        if (isOpen) {
            $panel.attr('hidden', true);
        } else {
            $panel.removeAttr('hidden');
        }
    });


    $(document).on('click', '.nasi-radovi__filters__btn', function () {
        const $btn   = $(this);
        const filter = $btn.data('filter');

        $btn.siblings().removeClass('--active');
        $btn.addClass('--active');

        $('.nasi-radovi__grid__card').each(function () {
            const $card     = $(this);
            const vrsta     = $card.data('vrsta') || '';
            const latestAll = String($card.data('latest-all')) === '1';

            if (filter === 'all') {
                if (latestAll) {
                    $card.removeClass('--hidden');
                } else {
                    $card.addClass('--hidden');
                }
            } else {
                if (vrsta.split(' ').includes(filter)) {
                    $card.removeClass('--hidden');
                } else {
                    $card.addClass('--hidden');
                }
            }
        });
    });


    $(document).on('click', '.program-radionica__tabs__btn', function () {
        const $btn  = $(this);
        const tab   = $btn.data('tab');

        $btn.siblings().removeClass('--active');
        $btn.addClass('--active');

        $('[data-panel]').hide();
        $('[data-panel="' + tab + '"]').show();
    });

    const $firstTab = $('.program-radionica__tabs__btn.--active').first();
    if ($firstTab.length) {
        $('[data-panel="' + $firstTab.data('tab') + '"]').show();
    }


    $(document).on('click', 'a[href*="#"]', function (e) {
        const href = $(this).attr('href');
        const hash = href.indexOf('#') !== -1 ? href.split('#')[1] : '';
        if (!hash) return;

        const $target = $('#' + hash);
        if (!$target.length) return;

        e.preventDefault();

        $('html, body').animate({
            scrollTop: $target.offset().top - ($header.outerHeight() + 16)
        }, 500);
    });


    $(document).on('click', '.radovi-archive__filter', function () {
        const $btn    = $(this);
        const filter  = $btn.data('filter');

        $('.radovi-archive__filter').removeClass('active');
        $btn.addClass('active');

        $('.radovi-archive__grid__item').each(function () {
            const $card    = $(this);
            const kategory = $card.data('kategory') || '';

            if (filter === 'sve' || kategory.split(' ').includes(filter)) {
                $card.removeClass('hidden');
            } else {
                $card.addClass('hidden');
            }
        });
    });


    $(document).on('click', '.single-hero__switcher .single-hero__tag', function (e) {
        e.stopPropagation();
        const $tag      = $(this);
        const $switcher = $tag.closest('.single-hero__switcher');
        const isOpen    = $switcher.hasClass('--open');

        if (!isOpen) {
            $switcher.addClass('--open');
            return;
        }

        $switcher.find('.single-hero__tag').removeClass('single-hero__tag--active');
        $tag.addClass('single-hero__tag--active');
        $switcher.removeClass('--open');
    });

    $(document).on('click', function () {
        $('.single-hero__switcher.--open').removeClass('--open');
    });


    if (typeof smok3d !== 'undefined' && smok3d.postId) {
        $('.wpcf7-form').each(function () {
            if (!$(this).find('input[name="product_id"]').length) {
                $(this).append('<input type="hidden" name="product_id" value="' + smok3d.postId + '">');
            }
        });
    }

});

jQuery(function ($) {
$('[data-fancybox="gallery"]').fancybox({
animationEffect: false,
image: {
preload: true
}
});
});